import { FC, ReactNode } from 'react'

import { ReactComponent as RejectIcon } from 'assets/reject.svg'

import s from './s.module.scss'

type Props = {
  children: ReactNode
}
const Reject: FC<Props> = ({ children }) => {
  return (
    <>
      <RejectIcon className={s.successIcon} />
      <div className={s.decorLeft} />
      <div className={s.decorRight} />
      <div className={s.content}>
        <h1>
          Error. Something <br /> goes wrong
        </h1>
        {children}
      </div>
    </>
  )
}

export default Reject
